module.exports = __webpack_public_path__ + "static/media/go-arrow.177c56d6.svg";